import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfessionalsListComponent } from './professionals-list/professionals-list.component';
import { RenderersModule } from 'src/app/shared/renderers/renderers.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { ProfessionalsFormComponent } from './professionals-form/professionals-form.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [
    ProfessionalsListComponent,
    ProfessionalsFormComponent
  ],
  imports: [
    CommonModule,
    RenderersModule,
    ReactiveFormsModule,
    FormsModule,
    NgxMaskModule,
    SharedModule
  ]
})
export class ProfessionalsModule { }
